import React, { useState } from "react";
import DashboardTitleComponent from "../../components/layout/Dashboard/Title/DashboardTitleComponent";
import CaixaSearchComponent from "./components/CaixaSearchComponent";
import CaixaInfosComponent from "./components/CaixaInfosComponent";
import { resumoMock } from "./data";
import ModalCriaMovimentoComponent from "./components/ModalCriaMovimentoComponent";
import ModalListaSessoesComponent from "./components/ModalListaSessoesComponent";

export interface Sessao {
    id: number;
    status: string;
    abertoEm: Date;
    valor: number;
}

export interface ResumoCaixa {
    saldoInicial: number;
    suprimentos: number;
    sangrias: number;
    vendasDinheiro: number;
    vendasDinheiroIfood: number;
    recebimentosFiadoDinheiro: number;
    valorEmCaixa: number;
}

export interface IfoodResumo {
    pix: number;
    visa: number;
    mastercard: number;
    nubank: number;
    total: number;
    taxasEntrega: number;
    taxasAdicionais: number;
    descontos: number;
}

export interface PagamentosOffline {
    creditoMastercard: number;
}

export interface ResumoVendas {
    ifood: IfoodResumo;
    pagamentosOffline: PagamentosOffline;
    infosAdicionais: ResumoInfoAdicionais
}

export interface ResumoInfoAdicionais {
    valorProdutos: number;
    taxasEntrega: number;
    taxasAdicionais: number;
}

export interface ResumoGeral {
    sessao: Sessao;
    resumoCaixa: ResumoCaixa;
    resumoVendas: ResumoVendas;
    totalGeral: number;
}

export interface ModalMovimentoProps {
    title: string;
    open: boolean;
    valor: string;
    observacao: string;

    valorInformado?: string;
    valorEsperado?: string;
}

export interface ModalMovimentoConfirmProps {
    valor?: string;
    observacao?: string;
    valorInformado?: string;
    valorEsperado?: string;
}

interface ModalListaSessoesProps {
    open: boolean;
}

const CaixaPage = () => {
    const [modalMovimento, setModalMovimento] = useState<ModalMovimentoProps>({
        title: "",
        open: false,
        valor: "",
        observacao: ""
    });

    const [modalListaSessoes, setModalListaSessoes] = useState<ModalListaSessoesProps>({
        open: false
    });

    const [descricao, setDescricao] = useState<string>("");
    const [formaPgto, setFormaPgto] = useState<string[]>([]);
    const [tipoOperacao, setTipoOperacao] = useState<string[]>([]);

    const [resumo, setResumo] = useState<ResumoGeral>(resumoMock);

    const handleChangeDescricao = (value: string) => {
        setDescricao(value);
    }

    const handleChangeFormaPgto = (value: string[]) => {
        setFormaPgto(value);
    }

    const handleChangeTipoOperacao = (value: string[]) => {
        setTipoOperacao(value);
    }

    const handleClickImpressora = () => {
        alert("tenho que imprimir");
    }

    const handleChangeValor = (valor: string) => {
        setModalMovimento({
            ...modalMovimento,
            valor: valor
        });
    }

    const handleChangeObservacao = (observacao: string) => {
        setModalMovimento({
            ...modalMovimento,
            observacao: observacao
        });
    }

    const handlemodalMovimento = (title: string) => {
        setModalMovimento({
            title: title,
            open: true,
            valor: "", observacao: ""
        });
    }

    const handleCloseModal = () => {
        setModalMovimento({
            title: "",
            open: false,
            valor: "", observacao: ""
        });
    }

    const handleChangeValorInformado = (valor: string) => {
        setModalMovimento({
            ...modalMovimento,
            valorInformado: valor
        });
    }

    const handleSendMovimentacao = (data: ModalMovimentoConfirmProps) => {
        alert("enviei");
    }

    const handleOpenModalSessoes = () => {
        setModalListaSessoes({
            ...modalListaSessoes,
            open: true
        })
    }

    const handleCloseModalSessoes = () => {
        setModalListaSessoes({
            ...modalListaSessoes,
            open: false
        })
    }

    const handleClickSessaoAnterior = (id: number) => {
        handleCloseModalSessoes();
        alert("Devo abrir a sessão #" + id);
    }

    return <>
        <DashboardTitleComponent title="Caixa" />

        <ModalCriaMovimentoComponent
            open={modalMovimento.open}
            title={modalMovimento.title}
            valor={modalMovimento.valor}
            onChangeValor={(valor: string) => handleChangeValor(valor)}
            observacao={modalMovimento.observacao}
            onChangeObservacao={(observacao: string) => handleChangeObservacao(observacao)}
            onClose={() => {
                handleCloseModal()
            }}
            onConfirm={(data) => handleSendMovimentacao(data)}

            valorEsperado={modalMovimento.valorEsperado}
            valorInformado={modalMovimento.valorInformado}
            onChangeValorInformado={(valor: string) => handleChangeValorInformado(valor)}
        />

        <ModalListaSessoesComponent 
            open={modalListaSessoes.open}
            title="Caixas Anteriores"
            onClickSessao={(id: number) => handleClickSessaoAnterior(id)}
            onClose={() => handleCloseModalSessoes()}
            sessoes={[
                {id: 4440606, status: "FECHADO", abertoEm: new Date("2026-02-14"), valor: 725.52},
                {id: 4440605, status: "FECHADO", abertoEm: new Date("2026-02-13"), valor: 625.52},
                {id: 4440604, status: "FECHADO", abertoEm: new Date("2026-02-12"), valor: 885.11},
                {id: 4440603, status: "FECHADO", abertoEm: new Date("2026-02-12"), valor: 885.11}
            ]}
        />

        <CaixaSearchComponent
            descricao={descricao} onChangeDescricao={(value: string) => handleChangeDescricao(value)}
            formaPgto={formaPgto} onChangeFormaPgto={(value: string[]) => handleChangeFormaPgto(value)}
            optionsFormaPgto={[
                { value: "1", label: "Dinheiro" },
                { value: "2", label: "Cartão" },
                { value: "3", label: "Pago via iFood" },
                { value: "4", label: "Bitcoin" }
            ]}
            tipoOperacao={tipoOperacao} onChangeTipoOperacao={(value: string[]) => handleChangeTipoOperacao(value)}
            optionsTipoOperacao={[
                { value: "1", label: "Abertura" },
                { value: "2", label: "Venda" }
            ]}
            onClickSessoesAnteriores={() => handleOpenModalSessoes()}
            onClickSuprimento={() => handlemodalMovimento("Suprimento")}
            onClickSangria={() => handlemodalMovimento("Sangria")}
            onClickFecharCaixa={() => handlemodalMovimento("Fechar Caixa")}
        />

        <CaixaInfosComponent
            resumo={resumo}
            onClickImpressora={handleClickImpressora}
        />
    </>;
}

export default CaixaPage;